var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.414,
    height: 7.414,
    viewBox: "0 0 7.414 7.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M9,9l6,6m0-6L9,15",
    transform: "translate(-8.293 -8.293)",
    fill: "none",
    stroke: "#fcb814",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossYellow);
export default __webpack_public_path__ + "static/media/cross-yellow.13bb0cb9e7b62084a238697d6495c4e7.svg";
export { ForwardRef as ReactComponent };